import { Injectable } from '@angular/core';
import { Project, ProjectTree } from '../../models/project';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ProjectService } from '../project.service';

@Injectable()
export class ProjectDetailInstance {
  project: Project;
  $project: BehaviorSubject<Project> = new BehaviorSubject<Project>(null);
  rootProject: ProjectTree;
  error: any;

  constructor(private projectService: ProjectService) {

  }

  reload() {
    this.init(this.project.id);
  }

  init(id: number) {
    this.projectService.getProject(id)
      .subscribe(project => {
        this.project = project;
        this.$project.next(project);

        this.loadRootProject(this.project.root.id);
      }, err => {
        console.log(err);
        this.error = err;
      })
  }

  private loadRootProject(id: number) {
    this.projectService.getProjectTree(id).subscribe(project => {
      this.rootProject = project;
      console.log(this.rootProject);
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail.instance.ts